import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomMaterialModule } from '../material/custom-material.module'
import { ReactiveFormsModule } from '@angular/forms'

import { UploadImageComponent } from './upload-image/upload-image.component'
import { UploadFileComponent } from './upload-file/upload-file.component'
import { ImgCropperModule } from '../img-cropper/img-cropper.module'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    ImgCropperModule,
  ],
  declarations: [
    UploadFileComponent,
    UploadImageComponent
  ],
  exports: [
    UploadFileComponent,
    UploadImageComponent
  ]
})
export class UploadModule { }



// WEBPACK FOOTER //
// ./src/app/shared/upload/upload.module.ts